import { Map } from 'immutable'
import * as constants from './constants'

const root = state => state.get('targeting')
export const byId = state => root(state).get('targetsById', Map())
export const lastCreatedTargetId = state => root(state).get('lastCreatedTargetId', -1)
export const lastUpdatedTargetId = state => root(state).get('lastUpdatedTargetId', -1)

export const targets = id => state => byId(state).get(id)
export const targetsLoaded = state =>
  [constants.FETCH_TARGETS_SUCCESS, constants.UPDATE_TARGET_SUCCESS, constants.CREATE_TARGET_SUCCESS].includes(
    root(state).get('status')
  )

export const wasTargetCreated = state => [constants.CREATE_TARGET_SUCCESS].includes(root(state).get('status'))

export const wasTargetUpdated = state => [constants.UPDATE_TARGET_SUCCESS].includes(root(state).get('status'))


// WEBPACK FOOTER //
// ./src/scripts/app/modules/targeting/selectors.js